import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { format } from 'date-fns';
import './CopyrightLabel.css';

var CopyrightLabel = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(CopyrightLabel, _React$PureComponent);

  function CopyrightLabel() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = CopyrightLabel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        year = _this$props.year,
        company = _this$props.company,
        phrase = _this$props.phrase,
        privacyPolicyLink = _this$props.privacyPolicyLink;
    return /*#__PURE__*/React.createElement("div", {
      className: "fc-copyright-label"
    }, /*#__PURE__*/React.createElement("span", {
      role: "img",
      "aria-label": "Copyright"
    }, "\xA9"), /*#__PURE__*/React.createElement("span", null, year || format(new Date(), 'yyyy'), " ", company, " ", phrase), privacyPolicyLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "privacy-policy-link"
    }, privacyPolicyLink)));
  };

  return CopyrightLabel;
}(React.PureComponent);

export { CopyrightLabel as default };
CopyrightLabel.defaultProps = {
  company: '',
  phrase: '',
  year: null,
  privacyPolicyLink: null
};
CopyrightLabel.propOptions = {};
CopyrightLabel.dataPropsMap = {
  company: ['business', 'name']
};